module.exports = __webpack_public_path__ + "static/30-ans-background.7d53b754.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30-ans-background.jpg
// module id = 497
// module chunks = 136956383308509